import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import router from './router'
import request from './utils/request'
import assetUrl from './utils/assetUrl'

Vue.use(Antd)
Vue.prototype.$request = request
Vue.prototype.$assetUrl = assetUrl

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');


// 开启反调试（无限 debugger），防止查看接口
// 注意：这会导致开发者工具一旦打开就卡住
// (() => {
//   function block() {
//     setInterval(() => {
//       (function() {
//         return false;
//       })['constructor']('debugger')['call']();
//     }, 50);
//   }
//   try {
//     block();
//   } catch (err) {
//     // ignore
//   }
// })();
